import ApiResponse from '@/models/entities/api/api-response';
import {
  VERIFY_EMAIL_RESPONSE_TYPE,
  VerifyEmailResponseType,
} from '@/models/entities/api/authorization-resource/verify-email-response-type';
import { validateEnumProperty } from '@/models/entities/type-utils';

export default class VerifyEmailResponse extends ApiResponse {
  parsedEmailResponseType: VerifyEmailResponseType;

  constructor(source: unknown) {
    super(source);
    this.parsedEmailResponseType = validateEnumProperty(
      source,
      'type',
      VERIFY_EMAIL_RESPONSE_TYPE,
      false,
    );
  }
}
